<template>
    <div>
        <v-row class="ma-n12px ma-md-n26px">
            <v-col v-for="giftcard in giftcards" :key="giftcard?._id" cols="6" md="4" lg="3" class="pa-12px pa-md-26px">
                <v-img class="border" :src="`https://daehanbooksgiftcard.com/${giftcard?.thumb}`" max-width="500" :aspect-ratio="500 / 500" contain>
                    <template v-if="getCommission(giftcard)">
                        <v-chip class="commission-chip" color="red" text-color="white" small>{{ `${getCommission(giftcard)}% 수수료` }}</v-chip>
                    </template>
                </v-img>
                <div class="text-center py-12px py-md-16px">
                    <div class="font-size-14 font-size-md-16 text-truncate font-weight-bold">{{ giftcard?.name }}</div>
                    <div class="font-size-16 font-size-md-18 mt-6px">
                        <b class="primary--text">{{ getSalePrice(giftcard) }}</b> 원
                    </div>
                </div>
                <div>
                    <v-btn class="font-size-16 font-size-md-18" large block color="primary" @click="order(giftcard)">구매하기</v-btn>
                </div>
            </v-col>
        </v-row>
        
        <giftcard-topping-popup ref="giftcardToppingPopup" />
        <giftcard-ats-popup ref="giftcardAtsPopup"/>
        <giftcard-dialog ref="giftcardDialog" />
        <login-dialog ref="loginDialog" />
        <kcp-cert ref="kcpCert" />
    </div>
</template>

<script>
import KcpCert from "@/components/plugins/kcp/kcp-cert.vue";
import GiftcardDialog from "./giftcard-dialog.vue";
import LoginDialog from "../../login/login-dialog.vue";
import GiftcardAtsPopup from "./giftcard-ats-popup.vue";
import GiftcardToppingPopup from "./giftcard-topping-popup.vue";

export default {
    components: {
        KcpCert,
        GiftcardDialog,
        LoginDialog,
        GiftcardAtsPopup,
        GiftcardToppingPopup
    },
    props: {
        giftcards: { type: Array, default: () => [] },
        me: { type: Object, default: () => ({}) },
    },
    methods: {
        login() {
            return new Promise((resolve, reject) => {
                if (this.logon) resolve();
                else {
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", (_) => resolve());
                    this.$refs.loginDialog.$on("cancel", (_) => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },
        // 로컬 테스트용
        // async getAccessToken(){
        //     await this.$store.dispatch("refresh", { refreshToken: this.refreshToken, _cert: "622af4183dae29e48d8a3e08" });
        //     alert(this.$store.state.payload);
        //     alert(this.$store.state.scope);
        // },
        certificate() {
            return new Promise((resolve, reject) => {
                if (this.scope?.includes?.("cert")) resolve();
                else {
                    this.$refs.kcpCert.$off();
                    this.$refs.kcpCert.$on("input", async ({ _cert }) => {
                        console.log(_cert);
                        await this.$store.dispatch("refresh", { refreshToken: this.refreshToken, _cert });
                        resolve();
                    });

                    this.$refs.kcpCert.open();
                }
            });
        },
        order(giftcard) {
            if (!this.me.ci) {
                alert("구매 권한이 없습니다.\n[로그인 > 마이페이지 > 회원정보수정 > 본인인증받기] 등록 후 이용해주세요.");
                this.$router.push("/mypage/profile");
                return;
            }
            this.login()
                .then(this.certificate)
                .then(async (_) => {
                    this.$refs.giftcardDialog.giftcard = giftcard;
                    this.$refs.giftcardDialog.open();
                    if(!this.$cookies.get("fts_popup")) {
                        this.$refs.giftcardAtsPopup.giftcard = giftcard;
                        this.$refs.giftcardAtsPopup.shows = true;
                    }
                    if(giftcard.platform == "topping" && !this.$cookies.get("topping_popup")){
                        this.$refs.giftcardToppingPopup.giftcard = giftcard;
                        this.$refs.giftcardToppingPopup.shows = true;
                    }
                });
        },

        getCommission(giftcard) {
            return giftcard[this.me.riskManagement.giftcard.level + "Commission"];
        },

        getSalePrice(giftcard) {
            const commissionAmount = (giftcard.faceamt * this.getCommission(giftcard) / 100);

            return Math.round(giftcard.faceamt + commissionAmount).format();
        },
    },
    computed: {
        refreshToken() {
            return this.$store.state.refreshToken;
        },
        accessToken() {
            return this.$store.state.accessToken;
        },
        scope() {
            return this.$store.state.scope;
        },
        logon() {
            return !!this.accessToken;
        },
    },
    watch: {
        "filter.mode"() {
            this.search(true);
        },
        "filter.searchValue"() {
            this.search(true);
        },
        "$props.mode"() {
            this.filter.mode = this.mode;
        },
        "$props.searchKey"() {
            this.filter.searchKey = this.searchKey;
        },
        "$props.searchValue"() {
            this.filter.searchValue = this.searchValue;
        },
        category() {
            this.page = 1;
            this.filter.category = this.category.code;
            this.search(true);
        },
    },
};
</script>

<style scoped>
.v-btn-toggle >>> .v-btn {
    opacity: 1 !important;
}

.commission-chip {
    position: absolute;
    top: 5px;
    right: 5px;
    border-radius: 999px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 14px !important;
    height: 20px !important;
    font-size: 10px !important;
}
</style>
